import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'h1-button',
})
export default class H1Button extends IconButton {
}
